$mol_time_duration_demo $mol_example_code
	title \Time processing library sandbox
	code? \
		\const week = new $mol_time_duration( 'P7D' )
		\const days = week.count( 'P1D' )
	aspects /
		\Type/Time
